import React, { useState } from "react";
import { useGlobalState } from "../../services/hostelConst";
import SaveFormModal from "./saveForm";
import ValidationModal from "./validationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../services/redux/reducers/modalSlice";

const SaveFormButton = ({
  navigate,
  refresh,
  isEditing = false,
  formId = null,
  formData = null, // Add formData prop
}) => {
  const dispatch = useDispatch();
  const customFormBuilder = useSelector((state) => state.customFormBuilder);
  const [validationErrors, setValidationErrors] = useState([]);

  const validateForm = () => {
    const errors = [];

    // Check if there are any sections
    if (!customFormBuilder || customFormBuilder.length === 0) {
      errors.push(
        "Your form is empty. Please add at least one section with elements."
      );
      return errors;
    }

    // Check if there are elements in the form
    const hasElements = customFormBuilder.some(
      (section) => section.elements && section.elements.length > 0
    );

    if (!hasElements) {
      errors.push(
        "Your form has no elements. Please add at least one form element."
      );
      return errors;
    }

    // Check if form has at least one eligible primary field (email type or number input)
    let hasEligiblePrimaryField = false;

    // Track field names to check for duplicates
    const fieldNames = new Map();

    // Validate each element in each section
    customFormBuilder.forEach((section, sectionIndex) => {
      if (!section.elements) return;

      section.elements.forEach((element, elementIndex) => {
        // Skip elements that don't need validation (like dividers, text blocks, etc.)
        if (
          ["divider", "text", "text-title", "button", "image"].includes(
            element.id
          )
        ) {
          return;
        }

        console.log("Validating element:", element);
        // Check if element is eligible to be a primary field
        if (
          (element.id === "text-input" &&
            element.style?.inputType === "email") ||
          (element.id === "text-input" && element.style?.inputType === "mobile")
        ) {
          hasEligiblePrimaryField = true;
        }

        const elementLabel = element.style?.label?.label || "Unnamed Field";

        // Check for unnamed fields
        if (!elementLabel || elementLabel === "Unnamed Field") {
          errors.push(
            `Field at section ${sectionIndex + 1}, position ${
              elementIndex + 1
            } has no label.`
          );
        }

        // Check for duplicate field names
        if (fieldNames.has(elementLabel)) {
          const existingField = fieldNames.get(elementLabel);
          errors.push(
            `Duplicate field name "${elementLabel}" found in section ${
              sectionIndex + 1
            } and section ${existingField.section + 1}.`
          );
        } else {
          fieldNames.set(elementLabel, {
            section: sectionIndex,
            index: elementIndex,
          });
        }

        // For required select/multiselect fields, check if options are provided
        if (
          element.style?.isRequired &&
          ["select", "multiSelect", "radio"].includes(element.id)
        ) {
          if (!element.style.options || element.style.options.length === 0) {
            errors.push(
              `Required field "${elementLabel}" has no options defined.`
            );
          }
        }
      });
    });

    // Add error if no eligible primary field exists
    if (!hasEligiblePrimaryField) {
      errors.push(
        "Your form must have at least one email field or number input to be used as the primary field."
      );
    }

    return errors;
  };

  const handleSaveClick = () => {
    // Validate the form before showing save modal
    const errors = validateForm();

    if (errors.length > 0) {
      setValidationErrors(errors);
      // Show validation error modal
      dispatch(
        openModal({
          isOpen: true,
          title: "Validation Errors",
          body: (
            <ValidationModal
              errors={errors}
              onClose={() => dispatch(closeModal())}
            />
          ),
          isEditing: false,
          size: "md",
        })
      );
    } else {
      dispatch(
        openModal({
          isOpen: true,
          title: isEditing ? "Update Form" : "Save Form",
          body: (
            <SaveFormModal
              navigate={navigate}
              refresh={refresh}
              closeModal={() => dispatch(closeModal())}
              isEditing={isEditing}
              existingFormId={formId}
              navbarFormData={formData} // Pass formData from navbar
            />
          ),
          isEditing: false,
          size: "lg",
        })
      );
    }
  };

  return (
    <button className="btn btn-success btn-sm ms-2" onClick={handleSaveClick}>
      <i className={`bi ${isEditing ? "bi-arrow-repeat" : "bi-save"} me-1`}></i>
      {isEditing ? "Update Form" : "Save Form"}
    </button>
  );
};

export default SaveFormButton;
